import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { ContentCopy } from '@mui/icons-material';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { habuColors } from 'Theme';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch } from 'react-redux';


const CRQIDHandler = React.memo(({ CRQID, prefix = 'CRQ ID:' }) => {
  const dispatch = useDispatch();

  const handleCopy = () => {
    dispatch(showAlert({ message: 'CRQ ID Copied', type: 'success' }));
  };

  if (!CRQID) {
    return null;
  }

  return (
    <Box display='flex' alignItems='center'>
      <Typography variant='subtitle3' sx={{ color: habuColors.neutral[60] }}>
        {`${prefix} ${CRQID}`}
      </Typography>
      <Tooltip title='Copy CRQ ID'>
        <IconButton onClick={handleCopy}>
          <CopyToClipboard text={CRQID}>
            <ContentCopy />
          </CopyToClipboard>
        </IconButton>
      </Tooltip>
    </Box>
  );
});

CRQIDHandler.propTypes = {
  CRQID: PropTypes.string,
  prefix: PropTypes.string,
};

CRQIDHandler.defaultProps = {
  CRQID: '',
  prefix: 'CRQ ID:',
};

export default CRQIDHandler;

